import script from "./MessageBoardManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageBoardManagement.vue?vue&type=script&setup=true&lang=js"

import "./MessageBoardManagement.vue?vue&type=style&index=0&id=0bbfb540&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bbfb540"]])

export default __exports__